export interface Handler {
    [key: string]: Array<Function>
};
